"use client"

import React from "react";
import {cn} from "../utils";

export const HamburgerIcon = ({className, fillColor}: {
    className?: string,
    fillColor?: string,
} & React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg"
         fill="none"
         strokeWidth={1.5}
         viewBox="0 0 24 24"
         stroke={fillColor || "currentColor"}
         className={cn(className, "size-6")}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 9h16.5m-16.5 6.75h16.5"/>
    </svg>

);